import { useEffect, useRef } from 'react';
import type { Table } from '@tanstack/react-table';

import type { DataSchema, Schema } from 'types';

interface Props<T extends keyof P, P extends DataSchema> {
  actions: {
    getCurrentPage?: (pageIndex: number) => void;
    getPageSize?: (pageSize: number) => void;
  };
  pagination: {
    pageIndex: number;
    pageSize: number;
  };
  tableInstance: Table<Schema<T, P>>;
}

export const useTableEvents = <T extends keyof P, P extends DataSchema>({ actions, pagination }: Props<T, P>) => {
  const prevPageIndexRef = useRef<number>(pagination.pageIndex);
  const prevPageSizeRef = useRef<number>(pagination.pageSize);

  useEffect(() => {
    const currentPageIndex = pagination.pageIndex;

    if (actions.getCurrentPage && currentPageIndex !== prevPageIndexRef.current) {
      actions.getCurrentPage(currentPageIndex + 1);
      prevPageIndexRef.current = currentPageIndex;
    }
  }, [actions, pagination.pageIndex]);

  useEffect(() => {
    const currentPageSize = pagination.pageSize;

    if (actions.getPageSize && currentPageSize !== prevPageSizeRef.current) {
      actions.getPageSize(currentPageSize);
      prevPageSizeRef.current = currentPageSize;
    }
  }, [actions, pagination.pageSize]);
};
